// extracted by mini-css-extract-plugin
export default {"hero":"PrimaryHeader_hero__dRZFm","ourProphet":"PrimaryHeader_ourProphet__Z+-4x","globalLeadPastor":"PrimaryHeader_globalLeadPastor__aZbH7"};